import styled from "styled-components";
import { CartGroupContainer } from "@swiggy-private/cart-ui";

interface IStyles {
    isCollapsible?: boolean;
}

export const BillDetailCartGroupContainer = styled(CartGroupContainer)<IStyles>(({ theme, isCollapsible }) => ({
    position: "relative",
    padding: isCollapsible
        ? `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium} !important`
        : `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.large} !important`,
    boxShadow: "none !important",
}));
